import type { ApolloClient, NormalizedCacheObject } from "@apollo/client";

import { REACT_APP_TRACKING_GRAPH_ENDPOINT } from "@phoenix/config";
import { graphClient } from "@phoenix/util/graphql";

import CacheConfig from "./GraphHostConfig";

class GraphHost {
  private static instance: ApolloClient<NormalizedCacheObject>;

  static getInstance(): ApolloClient<NormalizedCacheObject> {
    if (!GraphHost.instance) GraphHost.instance = graphClient(REACT_APP_TRACKING_GRAPH_ENDPOINT, CacheConfig);
    return GraphHost.instance;
  }
}

export default GraphHost;
